export const PHONE_NUMBER_REGEX = /^\d{4,10}$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const urlEndPoints = {
    product : {
        // present in navbar : start
        VOICE_MAIL: "voice-mail",
        VCS: "voice-chat-service",
        VOICE_SMS: "voice-sms", 

        IVR_PODCAST: "ivr-podcast",
        IVR_LS: "ivr-language-support",
        IVR_M_WOMAN: "ivr-m-woman",
        IVR_QUIZ: "ivr-quiz",
        IVR_SPORT: "ivr-sport",
        IVR_M_HEALTH: "ivr-m-health",
        IVR_M_FARM: "ivr-m-farm",

        SDF: "sdf",
        CRBT: "crbt",
        BPP: "balance-plus-plus",
        USSD_CHAT: "ussd-chat",
        UCP_REPORTS: "ucp-reports",
        CCS: "call-completion-suite",
        // SMS_MANAGER: "sms-manager", // hidden, as per Asif sir's request.
        
        SCP: "self-care-portals",
        CRM: "crm",
        CVM: "cvm",
        GROUPY: "groupy",

        ATS: "anti-theft-solutions",
        // ECM: "emergency-credit-management", // ECM & EVC are same. So, ECM is not required anymore.
        EVC: "emergency-voice-credit", // not as in figma : 6 || wrong data in figma : 2 // lets skip as of now.
        
        M_FARM : "m-farm",
        M_EDUCATION: "m-education",
        M_WOMAN : "m-woman",
        M_SURVEY: "m-survey",
        M_SPORTS : "m-sports",

        M_HEALTH : "m-health",
        // NOD: "nurse-on-demand", // it's not in navbar. So, the data is not implemented for now
        
        UMS : "ums",
        // M_LEARNING: "m-learning",                // data not available
        // present in navbar : end

        // not-present in navbar : start
// below products are not compared with figma (except the commented one ), due to time limitations & data large quantity.
        IVR_CHAT_SERVICE : "ivr-chat-service",

        M_COMMERCE : "m-commerce",               // content is not updated in figma. ( updated around night 22/02/2025)
        M_TV: "m-tv",                            // content is not updated in figma. ( updated around night 22/02/2025)
        // not-present in navbar : end
    },
    Service: {
        DIGITAL_TRANSFORMATION: "digital-transformation",
        MARKETING_SALES_STRATEGY: "marketing-and-sales-strategy",
        CONSULTING_SERVICES: "consulting-services"
    },
    Company: {
        ABOUT_US: "about-us",
        CONTACT_US: "contact-us",
        // CAREER: "carrer"  // hidden, as per Asif sir's request.
    }
};